import Part from './Part'

export default Part
